import { AsyncStatus } from 'lib-shared-types-api';
import { useCallback, useState } from 'react';

import { uploadsApi } from 'apis/uploads';
import { axiosInstance } from 'app/app.api';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

import { UseUploadResult } from './useUpload.types';

/**
 * A hook that creates a presigned upload using the uploads endpoints and
 * uploads the file in one step.
 */
export const useUpload = (): UseUploadResult => {
  const dispatch = useAppDispatch();
  const [asyncStatus, setAsyncStatus] = useState<AsyncStatus>('uninitialized');
  const [url, setUrl] = useState<string>();
  const trigger = useCallback<UseUploadResult[0]>(
    async (arg) => {
      setAsyncStatus('pending');

      try {
        const {
          data: { upload_url, download_url },
        } = await dispatch(
          uploadsApi.endpoints.createPresignedUrls.initiate(arg),
        ).unwrap();

        await axiosInstance.put(upload_url, arg.file, {
          headers: { 'Content-Type': arg.file.type },
        });

        setAsyncStatus('fulfilled');
        setUrl(download_url);

        return {
          asyncStatus: 'fulfilled',
          url: download_url,
        };
      } catch {
        setAsyncStatus('rejected');

        return {
          asyncStatus: 'rejected',
        };
      }
    },
    [dispatch],
  );

  return [
    (arg) => trigger(arg),
    {
      asyncStatus,
      url,
    },
  ];
};
